/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_Q4Inputs */

const en_csv_to_json_faq_q4 = /** @type {(inputs: Csv_To_Json_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What delimiter is supported?`)
};

const ko_csv_to_json_faq_q4 = /** @type {(inputs: Csv_To_Json_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 구분자가 지원되나요?`)
};

const ja_csv_to_json_faq_q4 = /** @type {(inputs: Csv_To_Json_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どの区切り文字がサポートされていますか？`)
};

/**
* | output |
* | --- |
* | "What delimiter is supported?" |
*
* @param {Csv_To_Json_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_q4 = /** @type {((inputs?: Csv_To_Json_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_q4(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_q4(inputs)
	return ja_csv_to_json_faq_q4(inputs)
});